import Vue from 'vue'
import Vuex from 'vuex'

import audit from './module/audit'
import core from './module/core'
import currency from './module/currency'
import user from './module/user'
import customer from './module/customer'
import product from './module/product'
import bom from './module/bom'
import company from './module/company'
import bomVersion from './module/bomVersion'
import customerBomFile from './module/customerBomFile'
import pcb from './module/pcb'
import quote from './module/quote'
import app from './module/app'
import project from './module/project'
import part from './module/part'
import partSubstitute from './module/part-substitute'
import cost from './module/cost'
import search from './module/search'
import erp from './module/erp'
import purchasing from './module/purchasing'
import workflow from './module/workflow'
import componentSubstitution from './module/componentSubstitution'
import account from './module/account'
import qualityData from './module/qualityData'
import task from './module/task'
import order from './module/order'
import people from './module/people'
import department from './module/department'
import bomItemDataPlugin from './module/bomItemDataPlugin'
import contact from './module/contact'
import home from './module/home'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {
    //
  },
  modules: {
    audit,
    core,
    currency,
    user,
    customer,
    product,
    bom,
    company,
    customerBomFile,
    pcb,
    quote,
    app,
    project,
    part,
    partSubstitute,
    cost,
    search,
    erp,
    purchasing,
    workflow,
    componentSubstitution,
    bomVersion,
    account,
    qualityData,
    task,
    order,
    people,
    department,
    bomItemDataPlugin,
    contact,
    home
  }
})
